import { INVISIBLE_ERROR } from 'components-machine';

export const isVisibleError = (errorMessage: unknown): boolean => !!errorMessage && errorMessage !== INVISIBLE_ERROR;
